<div
  [ngClass]="{
    'ui-rtl': cls.currentDirection() === 'rtl',
    'ui-ltr': cls.currentDirection() === 'ltr'
  }"
  [dir]="cls.currentDirection()"
>

  <router-outlet />
  <p-toast key="br" position="bottom-right" />
</div>
